export enum ContentLibraryFormField {
  SEARCH = 'search',
  CATEGORIES = 'categories',
  FUNNEL_ID = 'funnelId',
}
